(function (angular) {
	'use strict';

	var submitButtonObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			cta: '@',
			form: '<',
			formId: '@',
			formSubmitted: '=?',
			submitCallback: '&?',
			cssClasses: '@?'
		},
		controller: [
			'$document',
			'$scope',
			SubmitButtonFunction
		],
		controllerAs: 'submitButton'
	};

	angular
		.module('formValidationModule')
		.component('submitButton', submitButtonObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/shared/form-validation/submit-button.html';
	}
	
	function SubmitButtonFunction(
		$document,
		$scope
	) {
		var submitButton = this;
		var formElem;
		
		submitButton.showValidationErrors = function() {
			submitButton.form.$setSubmitted();
		};

		submitButton.submit = function(){
			if(!submitButton.formSubmitted){
				submitButton.formSubmitted = true;

				if (angular.isDefined(submitButton.submitCallback)) {
					submitButton.submitCallback();
				} else if (angular.isDefined(submitButton.formId)) {
					$document[0].getElementById(submitButton.formId).submit();
				}
			}
		};

		function handleEnter(event){
			event.preventDefault();
			if(submitButton.form.$valid){
				submitButton.submit();
			} else {
				submitButton.showValidationErrors();
			}
		}

		function handleKeydown(event) {
			var isEnter = (angular.isDefined(event.key) && event.key === 'Enter') || (angular.isDefined(event.keyCode) && event.keyCode === 13);

			if (isEnter && event.target.type !== 'textarea') {
				$scope.$applyAsync(handleEnter(event));
			}
		}

		submitButton.$onInit = function() {
			formElem = $document[0].getElementById(submitButton.formId);
			formElem.addEventListener('keydown', handleKeydown, false);
		};

		submitButton.$onDestroy = function() {
			formElem.removeEventListener('keydown', handleKeydown, false);
		};
	}
})(window.angular);